var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPause = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/pause"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pause"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.15 19.61V5.39C11.15 4.04 10.58 3.5 9.14 3.5H5.51C4.07 3.5 3.5 4.04 3.5 5.39V19.61C3.5 20.96 4.07 21.5 5.51 21.5H9.14C10.58 21.5 11.15 20.96 11.15 19.61Z",
    fill: "#2C6EEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.5016 19.61V5.39C21.5016 4.04 20.9316 3.5 19.4916 3.5H15.8616C14.4316 3.5 13.8516 4.04 13.8516 5.39V19.61C13.8516 20.96 14.4216 21.5 15.8616 21.5H19.4916C20.9316 21.5 21.5016 20.96 21.5016 19.61Z",
    fill: "#2C6EEE"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPause, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pause.114242b1.svg";
export { ForwardRef as ReactComponent };